import React from 'react';
import CarouselBanners from './CarouselBanners';

export default function OffersGalery(props) {
  return <CarouselBanners itemsPerPage={3} isFeatured={true} {...props} />;
}
